import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {monthlyLoanAmt} from '../../objects/AssetsExpenses/loanAmtCalc_function';
import SixColumnDisplayCard from '../shared-components/six_column_display_card';
import LoanCalculatorText from './text/loan_calculator_text';
import NumberedListCard from '../game-views/numbered_list_card';
import LoanExerciseDataset from './Datasets/loan_exercise_dataset';
import calcPaydayLoanAmts from './objects/calc_payday_loan_amts';
import {Tooltip} from "@mui/material";

class LoanCalculatorModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         loanType: "General",
         errorsFound: false,
         expandIntroText: false,
         rerender: false,
         tooltipTimeUnit: "Choose whether the loan term is in days or years",
    };    
    this.loanParmArr = [];
    this.introText = LoanCalculatorText.introText;
    this.textArr = LoanCalculatorText.numberedListArr;
    this.exerciseText = "";
    this.message = "";
    this.initializeDisplayClasses();
    this.resetExerciseButtons();
  }

  initializeDisplayClasses(){
    this.loanTypeMsg = "";
    const defaultClass = "font-weight-bold";
    this.loanAmtClass = defaultClass;
    this.intRateClass = defaultClass;
    this.loanTermClass = defaultClass;
    this.messageClass = "text-right font-weight-bold";
  }

  calculateLoanAmounts(entryName){
    if (entryName === "Entered"){
          this.getFormFields();
          this.editInputParameters();
          if (this.parametersValid === true){
              if (this.intRate > 100 && this.loanTerm <= 365 &&
                  this.daysYears === "days"){
                  this.calculatorType = "PayDay";
              }else{
                  this.calculatorType = "Loan";
              }
              this.exerciseText = "";
              this.conclusionText = "";
              this.calcValuesEntered();
            }else{
              this.setState({errorsFound: true});
            }
    }else{
          this.exerciseText = "";
          this.calcExerciseValues(entryName);
    }
  }

  getFormFields(){
      this.loanAmount = document.getElementById("loanAmount").value;
      this.intRate = document.getElementById("intRate").value;
      this.daysYears = document.getElementById("daysYears").value;
      this.loanTerm = document.getElementById("loanTerm").value;
  }

  editInputParameters(){
      this.parametersValid = true;
      this.initializeDisplayClasses();
      this.message = "";
      const labelClass = "font-weight-bold";
      if (!this.loanAmount){
          this.parametersValid = false;
          this.loanAmtClass = labelClass + " text-danger";
      }
      if (!this.intRate){
          this.intRateClass = labelClass + " text-danger"
          this.parametersValid = false;
      }
      if (!this.loanTerm){
          this.loanTermClass = labelClass + " text-danger";
          this.parametersValid = false;
      }
      if (this.parametersValid === false){
          this.message = "Factor values are required and cannot be blank.";
           this.messageClass = "text-right font-weight-bold text-danger";
      }else{
      
          if (isNaN(this.loanAmount)){
              this.parametersValid = false;
              this.loanAmtClass = labelClass + " text-danger";
          }
          if (isNaN(this.intRate)){
              this.intRateClass = labelClass + " text-danger"
              this.parametersValid = false;
          }
          if (isNaN(this.loanTerm)){
              this.loanTermClass = labelClass + " text-danger";
              this.parametersValid = false;
          }
          if (this.parametersValid === false){
              this.message = "Factor(s) must be numeric and no special characters (commas, dollar sign, etc.).";
              this.messageClass = "text-right font-weight-bold text-danger";
          }
          if (this.parametersValid &&
            this.intRate > 100){
                if ((this.loanTerm > 1 && this.daysYears === "years") ||
                    (this.loanTerm > 365 && this.daysYears === "days")){
                    this.intRateClass = labelClass + " text-danger"
                    this.loanTermClass = this.intRateClass;
                    this.messageClass = "text-right font-weight-bold text-danger";
                    this.message = "Interest rate is GT 100 and Loan Term is more than 1 year."
                }
          }
      }
  }

  calcExerciseValues(exerciseName){
      switch (exerciseName){
          case "LoanAmount":
            this.loanAmountDisabled = true;
            break;
          case "InterestRate":
             this.interestRateButtonDisabled = true;
             break;
          case "LoanTerm":
             this.loanTermButtonDisabled = true;
             break;
          case "PayDay":
             this.payDayLoanButtonDisabled = true;
             break;
          default:
             break;
      }
      this.processExerciseValues(exerciseName);
  }

  processExerciseValues(exerciseName){
      this.loanParmArr = [];
      this.exerciseName = exerciseName;
      if (this.exerciseName === "PayDay"){
          this.calculatorType = "PayDay";
      }else{
          this.calculatorType = "Regular";
      }
      this.resetExerciseButtons();
      const exerciseObj = 
        LoanExerciseDataset.find(elem => elem.exerciseName === this.exerciseName);
      this.exerciseText = exerciseObj.text;
      this.conclusionText = exerciseObj.conclusion;
      const loanParmArr = exerciseObj.parametersArr;
      for (let i=0; i<loanParmArr.length; i++){
           this.loanAmount = loanParmArr[i].loanAmount;
           this.intRate = loanParmArr[i].intRate;
           this.loanTerm = loanParmArr[i].nbrYears;
           this.calcValuesEntered();
      }
  }
  
  calcValuesEntered(){   
    let totalAmtPaid = 0;
    var loanInfoString = {};
    var intRateLit = +this.intRate + "%";
    let loanTermLit = "";
    if (this.calculatorType === "PayDay"){
       //  eventhough this value in the input dataset says it is years, it is really days for payday loans.
          const nbrDays = this.loanTerm;  
          let financeCharge = calcPaydayLoanAmts(this.loanAmount, this.intRate, nbrDays);
          loanTermLit = (nbrDays / 7).toFixed(0) + " weeks";
          totalAmtPaid = +this.loanAmount + +financeCharge;
          loanInfoString={loanType: "Pay Day Loan", loanAmt: this.loanAmount,  
              intRate: intRateLit, loanTerm: loanTermLit, totalPaid: totalAmtPaid, 
              overpayAmt: financeCharge};   
    }else{
          const nbrYears = this.loanTerm;
          const intRate = this.intRate / 100;
          var monthlyLnAmt = monthlyLoanAmt(this.loanAmount, intRate, nbrYears, 
                this.state.loanType)
          var totalLoanMonths = nbrYears * 12;
          totalAmtPaid = monthlyLnAmt * totalLoanMonths;
          loanTermLit = (nbrYears + " years")
          loanInfoString={loanType: "Regular Loan", loanAmt: this.loanAmount, 
              intRate: intRateLit, loanTerm: loanTermLit, monthlyAmt: monthlyLnAmt, 
              totalPaid: totalAmtPaid}; 
    }
         
    this.loanParmArr.push(loanInfoString);
    if (this.loanParmArr.length > 5){
      this.loanParmArr.splice(0,1);
      this.message = 
        "Max of 5 calculations, the first entry has rolled off.  Click on the 'Clear/Reset' " +
          " button if you wish to clear all entries and start again."
    }
    this.setState({rerender: !this.state.rerender});
  }

  clearLoanParameters(){
    this.resetExerciseButtons();
    this.exerciseText = "";
    var i;
    for (i=0; i<=this.loanParmArr.length; i++){
        delete this.loanParmArr[i];
    }
    this.loanParmArr.length = 0;
    this.setState({rerender: !this.state.rerender});
  }

  resetExerciseButtons(){
      this.loanAmountButtonDisabled = false;
      this.interestRateButtonDisabled = false;
      this.loanTermButtonDisabled = false;
      this.multipleFactorsButtonDisabled = false;
      this.payDayLoanButtonDisabled = false;
  }
  
  expandIntroText(){
      this.setState({expandIntroText: true});
  }

  collapseIntroText(){
      this.setState({expandIntroText: false});
  }
 
  render() { 
      this.summaryRecordCounts = this.loanParmArr.map((counts,index) =>
     <SixColumnDisplayCard key={index} tableInfo={counts} index={index} tableType={"loans"}
         />
   );  
   if (this.state.expandIntroText === true){
    this.numberedList = this.textArr.map((textLine, key) =>
        <NumberedListCard key={key} text={textLine} />
  );
}
  return <>
    <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" scrollable="true"
       dialogClassName="extraCredit-modal-size" animation={false}>
      <Modal.Header className="backgroundTopBottom" closeButton>
        <Modal.Title>Loan Calculator</Modal.Title> 
      </Modal.Header>
      <Modal.Body>
        {this.props.calculatorSw === false  ?
        <span>
          <div className="row-100 ml-2 mr-2 mt-1">
            There are 3 key factors that impact what you have to pay on loans.
               The factors are the total amount of the loan, the cost of the loan (interest rate) 
               and the length of the loan (also called the loan term).  Interest rates
               are the amount that the lender charges in order to make the loan.  This is always
               a percentage of the total loan amount.  These three factors affect
               the amount you have to pay each month and the total amount that you will pay
               over the life of the loan. 
                  
               {this.state.expandIntroText ?
                    <div className="mt-2">
                        {this.introText}  
                        {this.numberedList}
                 
                        <span className="text-right">
                            <Button variant="outline-info" size="sm"
                                onClick={() => this.collapseIntroText()}>
                                    Display Less
                            </Button>
                        </span>
                    </div>
              :   
                    <span className="ml-4">
                        <Button variant="outline-info" size="sm"
                            onClick={() => this.expandIntroText()}>
                              Display More
                        </Button>
                    </span> 
              }  
            {this.props.loanChallenges   ?
              <div className="ml-2 font-weight-bold">
                Click the 'Close' button when you are done and ready to tackle the loan challenges.
              </div>
              :
                null
            }
          </div>  
        </span>
        :
                <p></p>
         }
        <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-2 p-2 ml-4">
                <div className="form-group">
                  <label className={this.loanAmtClass} htmlFor="loanAmount">Loan Amount:</label>
                  <input type="text" className="form-control" id="loanAmount" name="loanAmount" />
                </div>
              </div>

              <div className="col-sm-2 p-2 ml-4">
                <div className="form-group position-relative">
                  <label className={this.intRateClass} htmlFor="intRate">Interest Rate:</label>
                  <input type="number" className="form-control pr-4" id="intRate" name="intRate" step="0.1" />
                  <span style={{position: 'absolute', right: '15px', top: '38px', color: '#555',
                    pointerEvents: 'none', userSelect: 'none', }}>%</span>
                </div>
              </div>

              <div className="col-sm-2 p-2 ml-4">
                <div className="form-group">
                  <label className={this.loanTermClass} htmlFor="loanTerm">Loan Term:</label>
                  <input type="text" className="form-control" id="loanTerm" name="loanTerm" />
                </div>
              </div>

              <div className="col-sm-2 p-2 ml-4">
                <div className="form-group">
                  <Tooltip title={this.state.tooltipTimeUnit} arrow>
                  <label className="font-weight-bold" htmlFor="daysYears">Time Unit:</label>
                  </Tooltip>
                  <select 
                    className="form-control" id="daysYears" name="daysYears">
                      <option value="years">Years</option>
                      <option value="days">Days</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <table className="table table-hover">
            <thead>
              <tr className="thead-light">
                <th></th>
                <th className="p-0 text-right" scope="col">Loan Type</th>
                <th className="p-0 text-right" scope="col">Loan Amount</th>
                <th className="p-0 text-right" scope="col">Interest Rate</th>
                <th className="p-0 text-right" scope="col">Loan Term</th>
                  {this.calculatorType === "PayDay" ?
                    <>
                        <th className="p-0 text-right" scope="col">Total Amount Paid</th>
                        <th className="p-0 text-right" scope="col">Overpay Amt</th>
                    </>
                  :
                    <>
                        <th className="p-0 text-right" scope="col">Monthly Amount</th>
                        <th className="p-0 text-right" scope="col">Total Amount Paid</th>
                    </>
                  }
              </tr>
            </thead>
          <tbody>
              {this.summaryRecordCounts}
          </tbody>
        </table>
        {this.props.exerciseButtons   ? 
            <span>
                <div className="mt-2">
                  <b>Learn more about the loan factors: </b> Enter your own values (above) and click on the Calculate button
                  ...OR... click on one of the buttons below.  When you are done, click the Close button.
                  <div>
                    <Button className="mt-2"
                        disabled={this.loanAmountButtonDisabled} variant="info"  
                        onClick={() => this.calculateLoanAmounts("LoanAmount")}>
                            Loan Amount
                    </Button>
                    <Button className="mt-2 ml-2"
                        disabled={this.interestRateButtonDisabled} variant="info"  
                        onClick={() => this.calculateLoanAmounts("InterestRate")}>
                            Interest Rate
                    </Button>
                    <Button className="mt-2 ml-2"
                        disabled={this.loanTermButtonDisabled} variant="info"  
                        onClick={() => this.calculateLoanAmounts("LoanTerm")}>
                            Loan Term
                    </Button>
                     <Button className="mt-2 ml-2"
                        disabled={this.payDayLoanButtonDisabled} variant="info"  
                        onClick={() => this.calculateLoanAmounts("PayDay")}>
                            PayDay Loans
                    </Button>
                  </div>
                </div>
                <div className="text-left">
                    {this.exerciseText}
                </div>
                {this.exerciseText !== "" ?
                    <div><b>Conclusion:</b>&nbsp;{this.conclusionText}</div>
                  :
                    null
                }
            </span>
        :
            null
        }
  
        </Modal.Body>
        
        <Modal.Footer className="backgroundTopBottom">
              <div  className={this.messageClass}>{this.message}</div>
              <div className="ml-2">
                  <Button variant="primary"  onClick={() => this.props.onClose()}>
                      Close
                  </Button>
                  <Button className="ml-2" variant="primary"   onClick={() => this.clearLoanParameters()}>
                      Clear/Reset
                  </Button>
                  <Button className="ml-2" variant="primary"  onClick={() => this.calculateLoanAmounts("Entered")}>
                      Calculate
                  </Button>
              </div>
         </Modal.Footer>
      </Modal>

      
    </>
  }

 
}
export default LoanCalculatorModal;